import { keyframes } from 'styled-components'

export const fadeSlideIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(0.8rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`
